export const ContentSubjectOrder = ["MUSIC", "DANCE", "DRAMA"] as const
